import styled from "styled-components";
import { BaseGridContainer } from "views/utils/styles";

export const CardBannerContainer = styled(BaseGridContainer)`
	margin-top: 10px;
	position: relative;
	overflow: hidden;

	.leftArrow,
	.rightArrow {
		position: absolute;
		width: 36px;
		height: 90px;
		background: #000000;
		opacity: 0.5;
		z-index: 1;
		border-radius: 0px 4px 4px 0px;
		cursor: pointer;
		top: 50%;
		transform: translateY(-50%);

		&:after {
			display: inline-block;
			content: " ";
			height: 17px;
			width: 17px;
			border-color: #fff;
			border-style: solid;
			border-width: 2px 2px 0 0;
			position: absolute;
			top: 50%;
			margin-top: -6px;
			-webkit-transition: 0.3s;
			transition: 0.3s;
		}

		&:hover {
			transition: 0.3s;
			opacity: 0.8;
		}
	}

	.leftArrow {
		left: 0px;
		&:after {
			left: 13px;
			transform: rotate(-135deg);
		}
	}

	.rightArrow {
		right: 0px;
		border-radius: 4px 0px 0px 4px;
		&:after {
			right: 13px;
			transform: rotate(45deg);
		}
	}

	.scrollContainer {
		display: flex;

		li {
			list-style: none;
			margin-right: 15px;

			&:nth-last-child(1) {
				margin-right: 0px;
			}
		}
		a {
			display: block;
		}

		img {
			width: 420px;
			object-fit: cover;
			border-radius: 4px;
		}
	}
`;
